export const mergeUrlParams = (url, queryParams) => {
  const parsedUrl = new URL(url);

  if (Object.keys(queryParams).length === 0 || queryParams == '') return parsedUrl.toString();

  parsedUrl.search = parsedUrl.search !== '' ?
    `${parsedUrl.search}&${new URLSearchParams(queryParams)}` :
    new URLSearchParams(queryParams);

  return parsedUrl.toString();
};
